export default "__VITE_ASSET__CgPxiQ0a__"